import { useEffect } from 'react'

/**
 * Request to acquire a Wake Lock and release based on hook lifecycle.
 */
export function useWakeLock(shouldHoldLock?: boolean): void {
  useEffect(() => {
    let sentinel: WakeLockSentinel | undefined

    if ('wakeLock' in navigator) {
      const requestWakeLock = async () => {
        await sentinel?.release()
        sentinel = await navigator.wakeLock.request('screen')
      }

      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          requestWakeLock()
        }
      }

      if (shouldHoldLock) {
        requestWakeLock()
        document.addEventListener('visibilitychange', handleVisibilityChange)
      }

      return () => {
        sentinel?.release()
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    }
  }, [shouldHoldLock])
}
